import React, { useContext } from "react";
import { AssessmentProfilesStyles } from './Style'
import { Chip } from "components/Form";
import { AssessmentsContext } from "./AssessmentsContext";
import { profiles as profileKeys } from 'keys'
import ProfileCard from "./ProfileCard";

const AssessmentProfiles = () => {
    const { profiles } = useContext(AssessmentsContext)

    const profilesData = profiles.data?.data

    return (
        <AssessmentProfilesStyles>
            {profilesData &&
                <div className="profile-cards">
                    {profilesData.map((profileGroup, profileGroupIndex) =>
                        <div className="profile-item">
                            <div className="profile-item-name">
                                {"קצב "}
                                <div className="wrap-chip">
                                    <Chip {...profileKeys[profileGroup.words_per_minute_index]}>
                                        {profileKeys[profileGroup.words_per_minute_index].words_per_minute}
                                    </Chip>
                                </div>
                            </div>
                            <div className="profile-items">
                                {profileGroup.factored_percent_accuracy.map((profile, index) => {
                                    const currentIndex = profileGroupIndex * 3 + index

                                    return (
                                        <ProfileCard
                                            profile={{
                                                rating_index: profile.factored_percent_accuracy_index,
                                                test_takers: profile.test_takers
                                            }}
                                            ratingIndex={index + 1}
                                            ratingKey={"factored_percent_accuracy"}
                                            index={currentIndex}
                                            label="דיוק" />
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            }
        </AssessmentProfilesStyles>
    )
}

export default AssessmentProfiles